/*
* SundAir2019Plugin.js
*
* Description: This is our plugin object. It can be exported to be used anywhere.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
import { CONF_CLOSING_DAY_OF_MONTH, CONF_ENVIRONMENT, CONF_SLOT_ALLOWED_DELAY } from '../config.js';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { store } from '../stores/store';
import atcCallSigns from '../locales/atcCallSigns.json';

dayjs.extend(isoWeek);


const SundAir2021Plugin = {

    install(Vue) { // options

        Vue.loader = '';

        /***********************************************************************
        * Global: make_basic_auth()
        *
        * Desc: Build 'Authorization' Key for API Calls.
        * Note: At 'Login' .. params are passed.
        *
        */
        Vue.prototype.$make_basic_auth = function (params) {

            var Base64 = {},
                token,
                hash,
                user = params.username ? params.username : 'booking_website',
                password = params.password ? params.password : 'D1sq3ccfwests!';


            Base64 = {
                // private property
                keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

                // public method for encoding
                encode: function (input) {
                    var output = '',
                        chr1,
                        chr2,
                        chr3,
                        enc1,
                        enc2,
                        enc3,
                        enc4,
                        i = 0;

                    input = Base64.utf8_encode(input);

                    while (i < input.length) {
                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);

                        enc1 = chr1 >> 2;
                        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                        enc4 = chr3 & 63;

                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }

                        output = output + this.keyStr.charAt(enc1) + this.keyStr.charAt(enc2) + this.keyStr.charAt(enc3) + this.keyStr.charAt(enc4);
                    }

                    return output;
                },
                // private method for UTF-8 encoding
                utf8_encode: function (string) {
                    var utftext = '',
                        n,
                        c;

                    string = string.replace(/\r\n/g, '\n');

                    for (n = 0; n < string.length; n++) {
                        c = string.charCodeAt(n);

                        if (c < 128) {
                            utftext += String.fromCharCode(c);
                        } else if (c > 127 && c < 2048) {
                            utftext += String.fromCharCode((c >> 6) | 192);
                            utftext += String.fromCharCode((c & 63) | 128);
                        } else {
                            utftext += String.fromCharCode((c >> 12) | 224);
                            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                            utftext += String.fromCharCode((c & 63) | 128);
                        }
                    }

                    return utftext;
                }
            };

            token = user + ':' + password;
            hash = Base64.encode(token);


            return 'Basic ' + hash;

        }; // eof make_basic_auth()

        /***********************************************************************
        * Global: screenRotation()
        *
        * Desc: Portrait / Landscape.
        * Note:
        *
        */
        Vue.prototype.$isScreenPortrait = function () {

            return store.getters.get_isPortrait;

        }; // eof screenRotation()

        /***********************************************************************
        * Global: isDesktop()
        *
        * Desc: Screen larger then .
        * Note:
        *
        */
        Vue.prototype.$isDesktop = function () {

            return store.getters.get_isDesktop;

        }; // eof isDesktop()

        /***********************************************************************
        * Global: isSmallDesktop()
        *
        * Desc: Screen larger then .
        * Note:
        *
        */
        Vue.prototype.$isSmallDesktop = function () {

            return store.getters.get_isSmallDesktop;

        }; // eof isSmallDesktop()

        /***********************************************************************
        * Global: isMobile()
        *
        * Desc: Screen larger then .
        * Note:
        *
        */
        Vue.prototype.$isMobile = function () {

            return !store.getters.get_isMobile;

        }; // eof isMobile()

        /***********************************************************************
        * Global: header_language()
        *
        * Desc: Right Header Language to send.
        * Note:
        *
        */
        Vue.prototype.$header_language = function () {

            var lang = 'DE',
                localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')); // catch


            // Language in localStrage?
            if (localStorageLanguage !== null) {
                lang = localStorageLanguage.value.toUpperCase();
            }

            return lang;

        }; // eo function header_language()


        /***********************************************************************
        * Global: lookUpCurrentBase()
        *
        * Desc: Returns the current base the resource in based.
        * Note: If no Base History Entry found, return null.
        *
        * @param {Object[]} m (Base History List)
        * @returns {Object | null} (BaseHistoryEntry)
        */
        Vue.prototype.$lookUpCurrentBase = function (baseHistory) {

            let baseHistoryFiltered = [],
                baseStationEntryToReturn = null;


            //filter out every base in the future
            baseHistoryFiltered = baseHistory.filter((b) => dayjs(b.sinceDate).startOf('day').isBefore(dayjs()));

            //sort by date
            baseHistoryFiltered.sort((a, b) => a.sinceDate < b.sinceDate ? 1 : -1);

            //take the first one as shown base
            if (baseHistoryFiltered.length > 0) {
                baseStationEntryToReturn = baseHistoryFiltered[0];
            }


            return baseStationEntryToReturn;

        }; // eo function lookUpCurrentBase()



        /***********************************************************************
        * Global: isUserAllowedToUse()
        *
        * Desc: Checks if the corresponding grant is set.
        * Note:
        *
        * @param {string} type "OCC" | "ADMIN" | "READONLY" | "ANYTHING"
        * "ANYTHING" - is there any sc2.flights grant set?
        */
        Vue.prototype.$isUserAllowedToUse = function (type) {

            let userIsAllowedToUse = false;


            switch (type) {
                case 'ANYTHING':
                    if (store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.readonly') ||
                        store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.occ') ||
                        store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.admin') ||
                        store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.admin.restricted')) {
                        userIsAllowedToUse = true;
                    }
                    break;
                case 'READONLY':
                    if (store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.readonly')) {
                        userIsAllowedToUse = true;
                    }
                    break;
                case 'OCC':
                    if (store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.occ')) {
                        userIsAllowedToUse = true;
                    }
                    break;
                case 'ADMIN':
                    if (store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.admin') ||
                        store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.admin.restricted')) {
                        userIsAllowedToUse = true;
                    }
                    break;
                case 'ADMINRESTRICTED':
                    if (store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.admin.restricted')) {
                        userIsAllowedToUse = true;
                    }
                    break;
                case 'FUEL':
                    if (store.getters.get_Shared_UsersGrantsList.includes('sc2.flights.fuel')) {
                        userIsAllowedToUse = true;
                    }
                    break;
                default:
                    userIsAllowedToUse = false;
                    break;
            }


            return userIsAllowedToUse;

        }; // eo function isUserAllowedToUse()



        /***********************************************************************
        * Global: isEmpty()
        *
        * Desc:
        * Note: Checks if given Value is empty
        *
        * @param {Object[]} objectToCheck (Object to check)
        *
        */
        Vue.prototype.$isEmpty = function (objectToCheck) {

            if (objectToCheck === '') {
                return true;
            }
            if (objectToCheck === null) {
                return true;
            }
            if (objectToCheck === undefined) {
                return true;
            }

            if (objectToCheck.length === 0) {
                return true;
            }

            return false;

        }; // eo function isEmpty()


        /***********************************************************************
        * Global: getEventColors()
        *
        * Desc: Return Event Colors/Cls.
        * Note:
        *
        */
        Vue.prototype.$getEventColors = function (m) {

            const eventColors = [
                { flighttype: 'NULL', cls: 'flight_Commercial' },
                { flighttype: 'C', cls: 'flight_Commercial' },
                { flighttype: 'E', cls: 'flight_Technical' },
                { flighttype: 'T', cls: 'flight_Technical' },
                { flighttype: 'P', cls: 'flight_Positional' },
                { flighttype: 'F', cls: 'flight_Ferry' },
                { flighttype: 'V', cls: 'flight_AircraftVisit' },
                { flighttype: 'B', cls: 'flight_AircraftVisit' },
                { flighttype: 'AOG', cls: 'flight_AircraftOnGround' },
                { flighttype: 'flightLanded', cls: 'flight_Landed' },
                { flighttype: 'flightScheduled', cls: 'flight_Scheduled' },
                { flighttype: 'flightInAir', cls: 'flight_In_Air' }
            ];


            return eventColors;

        }; // eo function getEventColors()


        /*******************************************************************************
        * Filter:: 'dayjsUTCToLocal'
        *
        * Desc:
        * Note:
        *
        * @param {string} date (ISO Format - 2021-05-07T09:20:00+0300)
        * @return {string}
        */
        Vue.prototype.$dayjsUTCToLocal = function (date, format) {

            let formattedDate = null;


            if (format === undefined || format === null || format === '') {
                format = 'HH:mm';
            }

            if (date !== null && date !== '') {
                switch (format) {
                    case 'HH:mm':
                        formattedDate = date.substring(11, 16);
                        break;
                    default:
                        formattedDate = '';
                        break;
                }
            }


            return formattedDate;

        }; // eo function dayjsUTCToLocal()


        /***********************************************************************
        * Global: 'dayjsLocalToUTC'
        *
        * Desc:
        * Note:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        Vue.prototype.$dayjsLocalToUTC = function (date, format) {

            const dayOfWeek = [
                ' 0000007',
                ' 1000000',
                ' 0200000',
                ' 0030000',
                ' 0004000',
                ' 0000500',
                ' 0000060'
            ];
            let formattedDate = null,
                transformedWeekday = '';


            if (format === undefined || format === null || format === '') {
                format = 'HH:mm';
            }

            transformedWeekday = dayjs(date).utc().isoWeekday(dayjs(date).utc().day()).format('d') === '0' ? '7' : dayjs(date).utc().isoWeekday(dayjs(date).utc().day()).format('d');

            if (date !== null && date !== '') {
                switch (format) {
                    case 'HH:mm':
                        formattedDate = dayjs(date).utc().format('HH:mm');
                        break;
                    case 'DD.MM.YYYY HH:mm':
                        formattedDate = dayjs(date).utc().format('DD.MM.YYYY HH:mm');
                        break;
                    case 'DD.MM.YYYY':
                        formattedDate = dayjs(date).utc().format('DD.MM.YYYY');
                        break;
                    case 'dddd, DD.MM.YYYY':
                        formattedDate = dayjs(date).utc().format('dddd, DD.MM.YYYY');
                        break;
                    case 'YYYY-MM-DD':
                        formattedDate = dayjs(date).utc().format('YYYY-MM-DD');
                        break;
                    case 'YYYY-MM-DD +1':
                        formattedDate = dayjs(date).add(1, 'day').utc().format('YYYY-MM-DD');
                        break;
                    case 'YYYY-MM-DD +365':
                        formattedDate = dayjs(date).add(365, 'day').utc().format('YYYY-MM-DD');
                        break;
                    case 'dd, DD.MM.YYYY':
                        formattedDate = dayjs(date).utc().format(`DD.MM.YYYY (${transformedWeekday})`);
                        break;
                    case 'dd, DD.MM.YY':
                        // formattedDate = dayjs(date).utc().isoWeekday(dayjs(date).day()).format(`DD.MM.YY (${transformedWeekday})`); // changed: #198
                        formattedDate = dayjs(date).utc().format(`DD.MM.YY (${transformedWeekday})`);
                        break;
                    case 'vt':
                        // formattedDate = dayjs(date).utc().isoWeekday(dayjs(date).day()).format(`DD.MM.YY (${transformedWeekday})`); // changed: #198
                        formattedDate = dayjs(date).utc().format(`${transformedWeekday}`);
                        break;
                    case 'DDMMM':
                        formattedDate = dayjs(date).utc().format('DDMMM').toUpperCase();
                        break;
                    case 'HHmm':
                        formattedDate = dayjs(date).utc().format('HHmm');
                        break;
                    case 'DOW':
                        formattedDate = dayOfWeek[dayjs(date).utc().format('d')];
                        break;
                    default:
                        formattedDate = '';
                        break;
                }
            }


            return formattedDate;

        }; // eof dayjsLocalToUTC()

        /*******************************************************************************
        * Filter:: 'aircraftConfig'
        *
        * Desc:
        * Note:
        */
        Vue.prototype.$aircraftConfig = function (aircraftObject) {

            const aircraftType = [
                {
                    type: '320',
                    capacityY: 174
                },
                {
                    type: '320',
                    capacityY: 180
                },
                {
                    type: '319',
                    capacityY: 150
                }
            ];
            let foundAircraftType = null,
                aircraftConfig = '';

            aircraftConfig = aircraftObject.capacityY;

            foundAircraftType = aircraftType.find(a => a.capacityY === aircraftObject.capacityY);
            if (foundAircraftType) {
                aircraftConfig += foundAircraftType.type;
            }

            return aircraftConfig;

        }; // eof aircraftConfig()

        /*******************************************************************
        * isMismatchingSlot
        *
        * Desc:
        * Note:
        *
        */
        Vue.prototype.$isMismatchingSlot = function (scheduled, slot) {

            const me = this;
            let isMismatchingSlot = false;


            if (Math.abs(dayjs(scheduled).diff(dayjs(slot), 'minute')) > CONF_SLOT_ALLOWED_DELAY) {
                isMismatchingSlot = true;
            }
            if (slot === null) {
                isMismatchingSlot = true;
            }

            return isMismatchingSlot;

        }; // eo function isMismatchingSlot()

        /*******************************************************************************
        * Filter:: 'createATCCallSign'
        *
        * Desc: Create ATC Call Sign based on Flight No.
        * Note: Only possible if Flight No starts with SR.
        *
        * @param {string} flightNo (Format: /^[a-z]{1,3}\d{1,4}[a-z]{0,1}$/)
        * @return {string | undefined} ATC Call Sign
        */
        Vue.prototype.$createATCCallSign = function (input) {

            // eslint-disable-next-line prefer-const
            let flightNo = input,
                ATCCallSign = null,
                flightNoPrefix = '',
                flightNoNumbers = '',
                splitted = [],
                foundATCCallSign = '';


            if (flightNo.slice(-1).toUpperCase() === 'F') {
                flightNo = flightNo.slice(0, -1); // Ferry Flight No
            }

            if (/^SR\d{3,4}$/ig.test(flightNo) === false) {
                return ATCCallSign; // undefined
            }


            splitted = flightNo.match(/^SR|\d{3,4}$/ig);
            if (splitted.length < 2) {
                return ATCCallSign; // undefined
            }

            flightNoPrefix = splitted[0]; // "SR"
            flightNoNumbers = splitted[1];

            foundATCCallSign = atcCallSigns.find(atcCallSign => atcCallSign.flightNoPart === flightNoNumbers);
            if (foundATCCallSign) {
                foundATCCallSign = foundATCCallSign.atcCallSign;
            } else {
                return ATCCallSign;
            }

            ATCCallSign = foundATCCallSign;


            return ATCCallSign;

        }; // eo function createATCCallSign()


        /***********************************************************************
        * Global: vp_m()
        *
        * Desc: Mask Viewport.
        * Note: Loader Config here.
        *
        */
        Vue.prototype.$vp_m = function () {

            Vue.loader = this.$loading.show({
                // container: this.$refs.loadingContainer, // ?
                canCancel: false, // default false
                color: '#9F4378',
                loader: 'spinner',
                width: 64,
                height: 64,
                backgroundColor: '#ffffff',
                opacity: 0.5
            });

        }; // eo function vp_m()


        /***********************************************************************
        * Global: vp_m()
        *
        * Desc: Unmask Viewport.
        * Note:
        *
        */
        Vue.prototype.$vp_um = function () {

            Vue.loader.hide();

        }; // eo function vp_um()


        /***********************************************************************
        * Global: toc()
        *
        * Desc: Application Infos while Debugging.
        * Note: Now via config.js.
        *
        * @param {String} m (Message to log)
        */
        Vue.prototype.$toc = function (m) {

            var rm = CONF_ENVIRONMENT; // CONF_ENVIRONMENT;


            if (rm === 'DEV') {
                console.log(m);
            }

        }; // eo function toc()


        /***********************************************************************
        * Global: isActionAllowed()
        *
        * Desc: Check for: 'Is Action Allowed?'.
        * Note:
        *
        * @param {Object} objectToCheck ( {datesToCheck: '2019-12-24', isAdmin: true } )
        *
        */
        Vue.prototype.$isActionAllowed = function (objectToCheck) {

            // Admin is always allowed to perform actions.
            if (objectToCheck.isAdmin) {
                return true;
            }

            const closingDayOfActualMonth = CONF_CLOSING_DAY_OF_MONTH[dayjs().month()],
                todayIsBeforeClosingDayOfMonth = dayjs().startOf('day').isBefore(dayjs().set('date', closingDayOfActualMonth).startOf('day'));

            // Iterate over dates to check.
            for (const dateObject of objectToCheck.datesToCheck) {
                const date = dateObject;

                // If the date is in the future, action is allowed.
                if (dayjs(date).startOf('day').isAfter(dayjs())) {
                    continue;
                }

                // Check for date in current and previous month.
                const isPreviousMonth = dayjs(date).startOf('month').isSame(dayjs().subtract(1, 'month').startOf('month'));
                const isOlderMonth = dayjs(date).startOf('month').isSameOrBefore(dayjs().subtract(2, 'month').startOf('month'));

                if (todayIsBeforeClosingDayOfMonth) {
                    // If today is before closing date, only action on date older than previous month is not allowed.
                    if (isOlderMonth) {
                        return false;
                    }
                } else {
                    // If today is after closing date, action on date in previous month or older is not allowed.
                    if (isPreviousMonth || isOlderMonth) {
                        return false;
                    }
                }
            }

            // If none of the dates invalidated the action, it is allowed.
            return true;

        }; // eo function isActionAllowed()


        /***********************************************************************
        * Global: buildFlightUpdatePayload()
        *
        * Desc: Builds the flight update object.
        * Note:
        *
        * @param {Object} flight (Whole flight object)
        */
        Vue.prototype.$buildFlightUpdatePayload = function (flight) {

            let payload = {};

            /*******************************************************************
            * flightTypes
            *
            * Desc: different flight types with backend values
            * Note:
            *
            */
            const flightTypes = [
                    {
                        value: 'V',
                        backendValue: 'VIA'
                    },
                    {
                        value: 'D',
                        backendValue: 'DIRECT'
                    },
                    {
                        value: 'T',
                        backendValue: 'TRIA'
                    }
            ];// eo flightTypes

            /*******************************************************************
            * isFlightOvernight
            *
            * Desc: Is given flight a overnight flight?
            * Note: If departure time is after arrival time the flight is
            * Note: overnight.
            *
            */
            const isFlightOvernight = function (flight) {

                let isOvernight = false;

                const [dep_hour, dep_min] = flight.dep_sch_time.split(':');
                const [arr_hour, arr_min] = flight.arr_sch_time.split(':');


                if (String(dep_hour) + String(dep_min) >= String(arr_hour) + String(arr_min)) {
                    isOvernight = true;
                }
                if (String(dep_hour) + String(dep_min) === '0000' && String(arr_hour) + String(arr_min) === '0000') {
                    isOvernight = true;
                }

                return isOvernight;

            }; // eo function isFlightOvernight()

            /*******************************************************************
            * setServiceFlags()
            *
            * Desc: Sets a ServiceFlag if there is one
            * Note:
            *
            */
            const setServiceFlags = function (flight) {

                const me = this;
                const reservations = [];

                flight.baggageServiceReservation && reservations.push('BAGGAGE');
                flight.flightReservation && reservations.push('FLIGHT');
                flight.insuranceReservation && reservations.push('INSURANCE');
                flight.mealServiceReservation && reservations.push('MEAL');
                flight.medicalServiceReservation && reservations.push('MEDICAL');
                flight.seatReservation && reservations.push('SEAT');
                flight.standardServiceReservation && reservations.push('STANDARD');
                flight.trainReservation && reservations.push('TRAIN');


                return reservations.length > 0 ? reservations : [];

            }; // eo function setServiceFlags()

            /*******************************************************************
            * payload
            *
            * Desc: Builds the payload object for the flight update.
            * Note:
            *
            */
            payload = {
                // >>> Step 0: 'Meta Data' ---------------------
                idFlight: flight.idFlight,
                idStartSegment: flight.idStartSegment,
                idCreationChain: flight.idCreationChain,
                idCarrier: '43', // 43 = SUNDAIR
                keepCrewCI: false,
                keepCrewCO: false,
                // >>> Step 1: 'Flight Config' ---------------------
                idFlightConfiguration: flight.idAircraftConfig,
                flightComment: flight.flightComment,
                permissionNumber: flight.permissionNumber,
                mainServiceType: flight.mainServiceType,
                allowedServicesForReservation: setServiceFlags(flight),
                codeShare: flight.codeshare,
                routeLength: flight.routeLength,
                // >>> Step 2: 'Date Config' -----------------------
                flightDates: {
                    dateType: 'DATES',
                    dates: {
                        dates: [
                            // #185
                            dayjs(flight.dep_sch_time).format('YYYY-MM-DDT00:00:00[Z]')
                        ]
                    },
                    overNight: isFlightOvernight(flight)
                },
                // >>> Step 3: 'Route Config' ----------------------
                flightType: 'DIRECT',
                originFlightType: flightTypes.find(value => value.value === flight.flightType).backendValue,
                directFlightInfo: {
                    atcCallSign: flight.atcCallSign,
                    ab_arr_slt_hour: flight.arr_slt_time ? dayjs(flight.arr_slt_time).utc().format('HH') : null,
                    ab_arr_slt_minute: flight.arr_slt_time ? dayjs(flight.arr_slt_time).utc().format('mm') : null,
                    ab_dep_slt_hour: flight.dep_slt_time ? dayjs(flight.dep_slt_time).utc().format('HH') : null,
                    ab_dep_slt_minute: flight.dep_slt_time ? dayjs(flight.dep_slt_time).utc().format('mm') : null,
                    aptFromIataCode: flight.aptFrom.aptCode,
                    aptToIataCode: flight.aptTo.aptCode,
                    flightNo: flight.flightNo,
                    depSlotStatus: flight.depSlotStatus,
                    arrSlotStatus: flight.arrSlotStatus,
                    flightScheduledTime: {
                        departureHour: flight.dep_sch_time ? dayjs(flight.dep_sch_time).utc().format('HH') : null,
                        departureMinutes: flight.dep_sch_time ? dayjs(flight.dep_sch_time).utc().format('mm') : null,
                        arrivalHour: flight.arr_sch_time ? dayjs(flight.arr_sch_time).utc().format('HH') : null,
                        arrivalMinutes: flight.arr_sch_time ? dayjs(flight.arr_sch_time).utc().format('mm') : null
                    },
                    flightTime: {
                        departureHour: flight.dep_sch_time ? dayjs(flight.dep_sch_time).utc().format('HH') : null,
                        departureMinutes: flight.dep_sch_time ? dayjs(flight.dep_sch_time).utc().format('mm') : null,
                        arrivalHour: flight.arr_sch_time ? dayjs(flight.arr_sch_time).utc().format('HH') : null,
                        arrivalMinutes: flight.arr_sch_time ? dayjs(flight.arr_sch_time).utc().format('mm') : null
                    }
                }
            }; // eo payload

            return payload;

        }; // eo function buildFlightUpdatePayload()

        /***********************************************************************
        * Global: buildFlightUpdatePayload()
        *
        * Desc: Builds the flight update object.
        * Note:
        *
        * @param {Object} slot (Whole slot object)
        */
        Vue.prototype.$buildSlotUpdatePayload = function (slot) {

            let payload = {};

            /*******************************************************************
            * payload
            *
            * Desc: Builds the payload object for the flight update.
            * Note:
            *
            */
            payload = {
                aircraftType: slot.aircraftType,
                airport: slot.airport,
                airportRequested: slot.airportRequested,
                airportSlot: slot.airportSlot,
                changeDate: slot.changeDate,
                direction: slot.direction,
                directionRequested: slot.directionRequested,
                // "dow": [],
                flightNo: slot.flightNo,
                flightNoRequested: slot.flightNoRequested,
                flightType: slot.flightType,
                flightTypeRequested: slot.flightTypeRequested,
                fromDate: slot.fromDate,
                id: slot.id,
                idFlightSegment: slot.idFlightSegment,
                mainServiceType: slot.mainServiceType,
                newValue: slot.newValue,
                oldValue: slot.oldValue,
                slotTime: slot.slotTime,
                slotTimeRequested: slot.slotTimeRequested,
                status: slot.status,
                toDate: slot.toDate,
                triaAirport: slot.triaAirport,
                type: slot.type,
                viaAirport: slot.viaAirport
            };

            return payload;

        }; // eo function buildFlightUpdatePayload()

    } // eo install{}
};


export default SundAir2021Plugin;
